
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { BIconInfoCircle } from 'bootstrap-vue';
import { TicketStatusEnum } from '@gid/models';
import TicketsModule from '../../store/tickets.module';
import { SELECTABLE_TICKET_STATUSES, statusLabelKey } from './ticketStatus';

@Component({ components: { BIconInfoCircle } })
export default class TicketActionBar extends Vue {
  @Prop({ required: true }) ticket!: any;
  @Prop({ default: () => [] }) departments!: any[];
  @Prop({ default: () => [] }) agents!: any[];

  busy = false;
  reassignAgentId: string | null = null;

  get store(): TicketsModule {
    return getModule(TicketsModule, this.$store);
  }

  get statusOptions() {
    return SELECTABLE_TICKET_STATUSES.map((value) => ({
      value,
      text: this.$t(statusLabelKey(value)),
    }));
  }
  get departmentOptions() {
    return [
      { value: '', text: this.$t('tickets.no_department') },
      ...this.departments.map((d) => ({
        value: d.department_id,
        text: d.name,
      })),
    ];
  }
  get agentOptions() {
    return [
      { value: null, text: this.$t('tickets.reassign_placeholder') },
      ...this.agents.map((a) => ({
        value: a.id,
        text: a.email ? `${a.name} — ${a.email}` : a.name,
      })),
    ];
  }

  async onStatus(status: TicketStatusEnum) {
    if (!status || status === this.ticket.status) return;
    await this.push({ status });
  }
  async onDepartment(departmentId: string) {
    // LiveAgent's transfer API has no "clear department", so only forward a
    // move to an actual department; picking the placeholder is a no-op.
    if (!departmentId || departmentId === this.ticket.departmentId) return;
    await this.push({ departmentId });
  }
  async onAgent(agentId: string | null) {
    if (!agentId) return;
    await this.push({ agentId });
    this.reassignAgentId = null;
  }

  async push(changes: {
    status?: TicketStatusEnum;
    departmentId?: string;
    agentId?: string;
  }) {
    this.busy = true;
    try {
      await this.store.updateLiveAgent({ id: this.ticket.id, ...changes });
      this.$emit('updated');
      // Reconcile once the enqueued SINGLE_TICKET_SYNC has had a beat to run.
      window.setTimeout(() => {
        this.store.reconcileTicket(this.ticket.id).catch(() => {
          /* best-effort reconcile */
        });
      }, 4000);
    } catch (e) {
      this.$bvToast.toast(this.$t('tickets.update_failed') as string, {
        variant: 'danger',
        title: this.$t('tickets.headline') as string,
      });
    } finally {
      this.busy = false;
    }
  }
}
